import type { SchemaOf } from '../helpers';
import { objectSchemaOf, Joi } from '../helpers';

export interface ISignParams {
  payload: {
    aud: string;
    iat: number;
    exp: number;
    [key: string]: string | number | string[];
  };
}

const signParamsSchemaMap: SchemaOf<ISignParams> = {
  payload: Joi.object({
    aud: Joi.string().valid('https://aimeeblue.com/functions').required(),
    iat: Joi.number().required(),
    exp: Joi.number().required(),
  })
    .pattern(Joi.string(), [
      Joi.string(),
      Joi.number(),
      Joi.array().items(Joi.string()).max(10),
    ])
    .required(),
};

export const signParamsSchema = objectSchemaOf<ISignParams>(
  signParamsSchemaMap
);

export interface ISignResult {
  keyId: string;
  signedJwt: string;
}
